// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__MPPWZ","link":"HeaderSimple_link__BwzOu","inputSearch":"HeaderSimple_inputSearch__oiSCb"};